import { useTranslate } from "ra-core";
import { useWatch } from "react-hook-form";

import { renderMessageTemplate } from "../activityLog/activityLogRules";
import { SAMPLE_MESSAGE_PLACEHOLDER_VALUES } from "./activityTypeForm";

/**
 * Almikia Epic EA (TASK-113): the create/edit form's live preview of
 * `message_template`, rendered with sample placeholder values through the
 * TASK-110 `renderMessageTemplate` helper (ticket acceptance criterion) --
 * the stored template itself is never touched. Shared by
 * `DealActivityTypeCreate.tsx` and `DealActivityTypeEdit.tsx`.
 */
export function MessageTemplatePreview({ source }: { source: string }) {
  const translate = useTranslate();
  const template: string | null | undefined = useWatch({ name: source });

  if (!template) return null;

  const rendered = renderMessageTemplate(
    template,
    SAMPLE_MESSAGE_PLACEHOLDER_VALUES,
  );

  return (
    <div className="rounded-md border border-input bg-muted/30 p-3">
      <p className="text-xs font-medium text-muted-foreground mb-1">
        {translate("resources.deal_activity_types.fields.message_preview")}
      </p>
      <p className="text-[15px] whitespace-pre-line">{rendered}</p>
    </div>
  );
}
